<template>
  <div>
    <div class="topTis">
      <i class="el-icon-warning" style="color: #7B61FF; font-size: 14px"></i>
      <div class="desc">
        <p>
          礼品卡中奖后，用户需要在礼品卡详情页查看卡密及激活方式
        </p>
      </div>
    </div>
    <el-form :model="giftCardForm" label-width="130px">
      <el-form-item label="选择礼品卡:">
        <el-select
          v-model="giftCardForm.region"
          placeholder="请选择"
          @change="selectGift"
        >
          <el-option
            v-for="item in giftCardList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
            </el-option
          >
        </el-select>
        <el-button type="text" @click="refreshGiftCard">刷新</el-button>
        <el-button
          type="primary"
          class="btn-type"
          @click="createGiftCard"
          >创建礼品卡</el-button
        >
        <p>
          剩余
          <span style="color: #fe4d45">{{ giftCardForm.budgetRemain }}</span>
          张
        </p>
      </el-form-item>
      <el-form-item label="单份奖品:">
        <el-input
          v-model="giftCardForm.num"
          style="width: 220px"
          :disabled="true"
        ></el-input>
        张
      </el-form-item>
      <el-form-item style="margin-left: -130px">
        <el-button
          type="primary"
          style="width: 180px"
          :disabled="giftCardForm.budgetRemain == 0"
          @click="handleSelectGiftCard"
          >选择礼品卡</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    giftData: {
      type: Object,
      default: ()=>({})
    },
    giftCardList: {
      type: Array,
      default: () => ([]),
    }
  },
  data() {
    return {
      giftCardForm: {
        region: "",
        num: "1",
        budgetRemain: "",
        logo: "",
        name: ""
      }
    };
  },
  computed: {},
  watch: {
    giftData:{
      handler(newVal) {
      this.giftCardForm.region = newVal.region
      this.giftCardForm.budgetRemain = newVal.budgetRemain
      this.giftCardForm.logo = newVal.logo
      this.giftCardForm.name = newVal.name
    },
    deep: true,
    immediate: true
    }
  },
  mounted() {},
  methods: {
    refreshGiftCard() {
      this.$emit("refreshGiftCard")
    },
    createGiftCard() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 7 },
      });
      window.open(routeUrl.href, "_blank");
    },
    selectGift(id) {
      let obj = this.giftCardList.find(item=>item.id == id);
      this.giftCardForm.region = obj.id
      this.giftCardForm.logo = obj.planImg
      this.giftCardForm.budgetRemain = obj.actualBalance
      this.giftCardForm.name = obj.planName
    },
    handleSelectGiftCard() {
      this.$emit("handleGetGiftCard", this.giftCardForm);
    },
  },
};
</script>
<style lang="scss" scoped>
.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #f4f7ff;
  margin: 24px;
  padding: 12px;
  color: #333;
  margin-left: 0px;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
  .topTis_line {
    line-height: 25px;
    font-size: 12px;
  }
}
.btn-type {
  width: 180px;
  background: rgba(123,97,255,0.1);
  color:#7B61FF;
  border-radius: 4px;
}
</style>
